// Configuração de variáveis de ambiente
//
// Nota sobre Supabase URL:
//   Em produção usamos um reverse proxy no nginx em /supabase/* para contornar
//   ISPs/DNS que não resolvem *.supabase.co. O client Supabase é idêntico:
//   só muda a base URL. Mantemos fallback para a URL direta em dev.
const rawSupabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY;
const supabaseUrl = rawSupabaseUrl ? rawSupabaseUrl.replace(/\/$/, '') : rawSupabaseUrl;

export const config = {
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'https://app.giobrain.com'
  },
  supabase: {
    url: supabaseUrl,
    anonKey: supabaseAnonKey,
  },
  googleAnalytics: {
    measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-8BFMH05QML'
  },
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  },
  facebook: {
    appId: process.env.REACT_APP_FACEBOOK_APP_ID
  },
  mautic: {
    baseUrl: process.env.REACT_APP_MAUTIC_BASE_URL || '',
  },
}
